import { Sport } from '@/interfaces/sport';
import { EntityResource } from './entity.resource';

/**
 * Resource dyscyplin
 *
 * @export
 * @class SportResource
 * @extends {EntityResource<Sport>}
 */
export class SportResource extends EntityResource<Sport> {
  protected getFields = {
    id: true,
    name: true
  };

  protected listFields = {
    id: true,
    name: true
  };

  constructor() {
    super({ entityName: 'sport' });
  }
}

export const sportResource = new SportResource();
